<app-attendee-layout class="bookings">
  <header class="mb-3">
    <h1 class="title-4">
      {{ 'attendee.bookings.title' | translate }}
    </h1>
  </header>

  <p class="text-sm text-grey mb-3">
    {{ 'attendee.bookings.description' | translate }}
  </p>

  <app-router-tab-bar [tabBarLinks]="tabBarlinks">
    <router-outlet></router-outlet>
  </app-router-tab-bar>
</app-attendee-layout>
